//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from 'vuex';
import { generateComputed } from '../../common/functions/roles-computed-generator';
import CRUDGenerico from '../../shared-components/generico/CRUDGenerico';
import DivisaoForm from './DivisaoForm';
import DivisaoTabela from './DivisaoTabela';

export default {
  name: 'CadastroDivisao',
  extends: CRUDGenerico,
  data() {
    return {
      divisaoResources: this.$api.divisao(this.$resource),
      estruturaUsuarioResources: this.$api.estruturaUsuario(this.$resource),
      resourceMetadado: this.$api.metadado(this.$resource),
      parametrizacaoClienteResources: this.$api.parametrizacaoCliente(this.$resource),

      configCarteira: null,
    };
  },
  components: {
    DivisaoForm,
    DivisaoTabela,
  },
  computed: {
    ...generateComputed('Divisao', [
      'canEdit',
      'canGet',
      'canAccessPage',
    ]),
    ...mapGetters('metadados', [
      'getDivisaoMetadado',
    ]),
    somenteLeitura() {
      return !this.canEdit && this.canGet;
    },
    carregouMetadados() {
      const metadados = this.getDivisaoMetadado;
      return metadados != null;
    },
  },
  methods: {
    ...mapActions('metadados', [
      'setDivisaoMetadado',
    ]),
    accessForbidden() {
      if (!this.canAccessPage) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    popularMetadados() {
      if (this.getDivisaoMetadado) {
        return;
      }
      this.setDivisaoMetadado({
        resource: this.resourceMetadado.listarDivisao,
      });
    },
    onCancelar() {
      this.$refs.divisaoTabela.filtrar();
    },
    onEditarDivisao(divisao) {
      this.$refs.divisaoForm.editar(divisao);
      this.$refs.divisaoForm.buscarCarteirasCliente();
      this.$refs.divisaoForm.buscarDivisoesPorEstruturaDeUsuario();
      this.$refs.divisaoForm
        .buscarEstruturasDeUsuario(divisao.estruturaUsuario.nome);
    },
    onNovaDivisao() {
      this.$refs.divisaoTabela.filtrar();
    },
    requestPopular(page = null) {
      if (page && page.filter) {
        this.request(this.divisaoResources.listarFiltrado, page);
        return;
      }
      this.request(this.divisaoResources.listar, page);
    },
    verificaCarteira() {
      const chave = 'CARTEIRA';
      this.parametrizacaoClienteResources.buscar({ chave }).then((response) => {
        if (response.data) {
          this.configCarteira = response.data.valor;
        }
      }, (err) => {
        this.$error(this, err);
      });
    },
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => {
        this.accessForbidden();
      }, 1E3);
    } else {
      this.popularMetadados();
      this.verificaCarteira();
    }
  },
};



// WEBPACK FOOTER //
// ./src/spa/divisao/CadastroDivisao.vue?vue&type=script&lang=js&